import React, { FC, Dispatch, SetStateAction } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';

interface RadioButtonsMobileProps {
  radioOptions: any[];
  value: any;
  setValue: Dispatch<SetStateAction<any>>;
}

const RadioButtonsMobile: FC<RadioButtonsMobileProps> = (props) => {
  let { radioOptions, value, setValue } = props;

  return (
    <Grid container spacing={2}>
      {radioOptions.map((radioOption) => {
        const variant = radioOption.value.toString() === value?.toString() ? 'contained' : 'outlined';
        const backgroundColor = radioOption.value.toString() === value?.toString() ? '#546E7A' : 'white';

        return (
          <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }} key={radioOption.value}>
            <Button
              variant={variant}
              fullWidth
              style={{ minHeight: 50, backgroundColor: backgroundColor }}
              onClick={() => setValue(radioOption.value)}
            >
              {radioOption.label}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RadioButtonsMobile;
